<template>
    <div class="edit-building-details">
        <div v-if="buildingFields.length" class="edit-building-details__layout">
            <div class="edit-building-details__main">
                <div class="edit-building-details__grid">
                    <themed-form-field 
                        v-for="row in buildingFields" 
                        :key="row.field"
                        :label="row.label"
                        class="edit-building-details__field"
                    >
                        <themed-input
                            v-if="row.type === 'text'"
                            v-model="building[row.field]"
                            :placeholder="row.label"
                        />

                        <themed-number-input
                            v-else-if="row.type === 'integer' || row.type === 'double'"
                            v-model="building[row.field]"
                            :is-decimal="row.type === 'double'"
                        />

                        <themed-percent-input
                            v-else-if="row.type === 'percentage'"
                            v-model="building[row.field]"
                        />

                        <themed-currency-input
                            v-else-if="row.type === 'currency'"
                            v-model="building[row.field]"
                            is-decimal
                        />

                        <themed-select
                            v-else-if="row.type === 'value-list'"
                            v-model="building[row.field]"
                            :options="getValueListOptions(row.options)"
                            :placeholder="`Select ${row.label.toLowerCase()}`"
                        />
                    </themed-form-field>
                </div>
            </div>

            <div class="edit-building-details__sidebar">
                <div class="edit-building-details__toggles">
                    <div 
                        v-for="row in buildingToggleFields" 
                        :key="row.field"
                        class="edit-building-details__toggle-item"
                    >
                        <label :for="row.field" class="edit-building-details__toggle-label">
                            {{ row.label }}
                        </label>
                        <themed-toggle
                            :id="row.field"
                            :value="getBooleanValue(row.field)"
                            @input="updateBooleanField(row.field, $event)"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ThemedFormField from '../../form/ThemedFormField.vue';
    import ThemedInput from '../../ThemedInput.vue';
    import ThemedSelect from '../../ThemedSelect.vue';
    import ThemedToggle from '../../ThemedToggle.vue';
    import ThemedNumberInput from '../../form/ThemedNumberInput.vue';
    import ThemedPercentInput from '../../form/ThemedPercentInput.vue';
    import ThemedCurrencyInput from '../../form/ThemedCurrencyInput.vue';

    export default {
        name: 'EditBuildingDetails',

        components: {
            ThemedFormField,
            ThemedInput,
            ThemedSelect,
            ThemedToggle,
            ThemedNumberInput,
            ThemedPercentInput,
            ThemedCurrencyInput
        },

        props: {
            buildingData: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                building: this.buildingData,
                buildingTypes: []
            }
        },

        created() {
            this.initBuildingTypes();
        },

        computed: {
            buildingFields() {
                if (this.buildingTypes.length && this.building.type_id != null) {
                    let fields = _.find(this.buildingTypes, ['id', this.building.type_id])?.fields || [];
                    
                    return fields.filter(field => field.type !== 'boolean');
                }

                return [];
            },

            buildingToggleFields() {
                if (this.buildingTypes.length && this.building.type_id != null) {
                    let fields = _.find(this.buildingTypes, ['id', this.building.type_id])?.fields || [];
                    
                    return fields.filter(field => field.type === 'boolean');
                }

                return [];
            }
        },

        methods: {
            initBuildingTypes() {
                axios.get('/api/building-types')
                    .then((response) => {
                        this.buildingTypes = response.data.types;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },

            getValueListOptions(options) {
                return options.map(option => ({
                    value: option.option,
                    label: option.option
                }));
            },

            getBooleanValue(field) {
                const value = this.building[field];
                // Convert 1/0, '1'/'0', null/undefined to boolean
                if (value === null || value === undefined) {
                    return false;
                }
                return Boolean(Number(value));
            },

            updateBooleanField(field, value) {
                // Update the building field with the boolean value
                this.$set(this.building, field, value);
            }
        }
    }
</script>
